module.exports = __webpack_public_path__ + "img/hold-dm.99c602d9.svg";